export default __webpack_public_path__ + "static/media/joint-chairman.d72abeac.jpg";